module.exports = __webpack_public_path__ + "static/media/tutorial-2.62646b97.svg";